var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.564 7.50922C14.5702 7.50918 14.5764 7.50918 14.5827 7.50918C16.6538 7.50918 18.3327 9.19117 18.3327 11.2661C18.3327 13.1998 16.8743 14.7923 14.9993 15M14.564 7.50922C14.5763 7.37172 14.5827 7.23247 14.5827 7.09174C14.5827 4.55579 12.5307 2.5 9.99935 2.5C7.60205 2.5 5.63462 4.34389 5.43303 6.69327M14.564 7.50922C14.4788 8.45633 14.1065 9.3205 13.535 10.0138M5.43303 6.69327C3.31933 6.89478 1.66602 8.67825 1.66602 10.8486C1.66602 12.8681 3.09748 14.5527 4.99935 14.9394M5.43303 6.69327C5.56457 6.68073 5.69787 6.67431 5.83268 6.67431C6.77087 6.67431 7.63663 6.98495 8.3331 7.50918",
    stroke: "#0E4A79",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 10.833V17.4997M9.99935 10.833C9.41585 10.833 8.32562 12.4949 7.91602 12.9163M9.99935 10.833C10.5828 10.833 11.6731 12.4949 12.0827 12.9163",
    stroke: "#0E4A79",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.4fd0f66ef5a28881221ad0e92914704a.svg";
export { ForwardRef as ReactComponent };